export default __webpack_public_path__ + "59422b6e2afc3b9c5bd190612ab0c3ec.svg";